module.exports = __webpack_public_path__ + "assets/img/rcode.c721348c.png";